import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { SharedService } from 'src/app/modules/gasprecio/services/shared.service';
import { GasprecioService } from 'src/app/modules/gasprecio/services/gasprecio.service';
import { Subscription } from 'rxjs';
import Highcharts from 'highcharts';

@Component({
  selector: 'app-chart-quotient-sale-level',
  templateUrl: './chart-quotient-sale-level.component.html',
  styleUrls: ['./chart-quotient-sale-level.component.scss']
})
export class ChartQuotientSaleLevelComponent implements OnInit, OnDestroy {

  @Input() station: any = false;
  n30;
  days = 30;
  days$!: Subscription;
  actual;
  n180;
  slope;
  optimum30;
  optimum180;
  idGroup = '60afa99655f4ee369d1df409';
  idGroup$!: Subscription;
  id;
  idStation;
  pointsQuarters = [{
    low: {
      min: null,
      max: null
    },
    mediumLow: {
      min: null,
      max: null
    },
    mediumHigh: {
      min: null,
      max: null
    },
    high: {
      min: null,
      max: null
    },
  }];
  productType = 'regular';
  productType$!: Subscription;
  reqst = 0;
  route;
  rol;
  stationId;

  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options = {
    credits: {
      enabled: false
    },
    chart: {
      type: 'scatter'
    },
    title: {
      text: 'Ventas desestacionalizadas lts - Indice de Precios',
      style: {
        fontSize: '0'
      }
    },
    xAxis: {
      gridLineWidth: 1,
      gridLineDashStyle: 'LongDash',
      title: {
        text: 'Indice de Precios',
        style: {
          fontSize: '11px'
        }
      },
      labels: {
        style: {
          fontSize: '11px',
        },
        format: '{value:,.3f}',
      },
      startOnTick: true,
      endOnTick: true
    },
    yAxis: {
      title: {
        text: 'Ventas desestacionalizadas',
        style: {
          fontSize: '11px'
        }
      },
      labels: {
        format: '{value:,.0f} lts.',
        style: {
          fontSize: '11px',
        }
      },
      tickAmount: 10,
      gridLineDashStyle: 'LongDash'
    },
    legend: {
      layout: 'vertical',
      align: 'right',
      verticalAlign: 'middle',
      itemDistance: 10,
      y: 1,
      padding: 1,
      itemMarginTop: 1,
      itemMarginBottom: 1,
      itemHoverStyle: {
        color: '#00E07B',
      }
    },
    exporting: {
      filename: 'Ventas desestacionalizadas lts - Indice de Precios',
      sourceWidth: 1200,
      sourceHeight: 800,
    },
    plotOptions: {
      scatter: {
        marker: {
          radius: 4,
          symbol: 'circle',
          states: {
            hover: {
              enabled: true,
              lineColor: 'rgb(100,100,100)'
            }
          }
        }
      }
    },
    series: []
  };

  constructor(
    private gasprecioService: GasprecioService,
    private sharedService: SharedService
  ) {
    this.productType$ = this.sharedService.sharedProductType.subscribe(productType => {
      if (this.productType !== productType) {
        this.productType = productType;
        if (this.reqst > 1) {
          this.setData();
        }
      }
    });
  }

  ngOnInit(): void {
    this.getLevelsActualScatter();
  }

  ngOnDestroy(): void {
    this.productType$.unsubscribe();
  }

  getLevelsActualScatter() {
    this.reqst = 1;
    this.stationId = localStorage.getItem('idStation');
    const url = this.gasprecioService.getLevelsActualScatter(this.productType);
    url.subscribe({
      next: (data: any) => {
        this.n30 = data['n_30'];
        this.n180 = data['n_150'];
        this.actual = data['actual'];
        this.optimum30 = data['optimum_30'];
        this.optimum180 = data['optimum_180'];
        this.slope = data['slope'];
        this.setData();
      }, complete: () => {
        this.reqst = 2;
      }, error: () => {
        this.reqst = 3;
      }
    });
  }

  setData() {
    this.reqst = 1;
    const seriesData = [];
    const color30 = '#06b0f0', color180 = '#c9eaff', colorSlope = '#000000', colorActual = '#124187', colorOptimum180 = '#00e07b', colorOptimum30 = '#90f4c5';
    const pos = this.productType === 'regular' ? 0 : this.productType === 'premium' ? 1 : 2;


    if (this.n30[pos]) {
      const n30Series = {
        name: '30 días',
        color: color30,
        data: this.n30[pos],
        tooltip: {
          pointFormatter: function () {
            return '<b>Ventas desestacionalizadas: ' + this.y.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' lts.<br/>Indice de Precios: ' + this.x.toFixed(3) + ' </b>';
          }
        }
      };
      seriesData.push(n30Series);
    }

    if (this.n180[pos]) {
      const n180Series = {
        name: '180 días',
        color: color180,
        data: this.n180[pos],
        tooltip: {
          pointFormatter: function () {
            return '<b>Ventas desestacionalizadas: ' + this.y.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' lts.<br/>Indice de Precios: ' + this.x.toFixed(3) + ' </b>';
          }
        }
      };
      seriesData.push(n180Series);
    }
    
    if (this.optimum30[pos]) {
      const optimum30Series = {
        name: 'Recomendado 30 días',
        color: colorOptimum30,
        data: this.optimum30[pos],
        tooltip: {
          pointFormatter: function () {
            return '<b>Ventas desestacionalizadas: ' + this.y.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' lts.<br/>Indice de Precios: ' + this.x.toFixed(3) + ' </b>';
          }
        }
      };
      seriesData.push(optimum30Series);
    }

    if (this.optimum180[pos]) {
      const optimum180Series = {
        name: 'Recomendado 180 días',
        color: colorOptimum180,
        data: this.optimum180[pos],
        tooltip: {
          pointFormatter: function () {
            return '<b>Ventas desestacionalizadas: ' + this.y.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' lts.<br/>Indice de Precios: ' + this.x.toFixed(3) + ' </b>';
          }
        }
      };
      seriesData.push(optimum180Series);
    }

    if (this.actual[pos]) {
      const actualSeries = {
        name: 'Actual',
        color: colorActual,
        data: this.actual[pos],
        tooltip: {
          pointFormatter: function () {
            return '<b>Ventas desestacionalizadas: ' + this.y.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' lts.<br/>Indice de Precios: ' + this.x.toFixed(3) + ' </b>';
          }
        }
      };
      seriesData.push(actualSeries);
    }

    


    if (this.slope[pos]) {
      const slopeSeries = {
        name: 'Pendiente',
        color: 'black',
        data: this.slope[pos],
        type: 'line',
        tooltip: {
          pointFormatter: function () {
            return '<b>Ventas desestacionalizadas: ' + this.y.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' lts.<br/>Indice de Precios: ' + this.x.toFixed(3) + ' </b>';
          }
        },
        marker: {
          radius: 0
        }
      };
      seriesData.push(slopeSeries);
    }
 
    this.chartOptions.series = [...seriesData];
    setTimeout(() => {
      this.reqst = 2;
    }, 100);
  }
}